import { GridSelectableSettings } from '@progress/kendo-react-grid/dist/npm/interfaces/GridSelectableSettings';
import { useTranslation } from 'react-i18next';
import useFiscalYearsTableColumns from 'src/assets/static/view_periods/useFiscalYearsTableColumns';
import GridWrapper from 'src/components/GridWrapper';
import Accordion from 'src/components/design-system/Accordion';
import useViewCalendarYear from 'src/hooks/useViewCalendarYear';
import FiscalYearsTableGridToolbar from './FiscalYearsTableGridToolbar';

const selectable: GridSelectableSettings = {
  enabled: true,
  drag: false,
  cell: false,
  mode: 'single',
};

const FiscalYearsTable = () => {
  const { t } = useTranslation();
  const columns = useFiscalYearsTableColumns();
  const { activeFY, pastFY, isGlPeriodsLoading } = useViewCalendarYear();

  return (
    <div className="mt-3 md:mr-3">
      <div className="flex justify-between p-2">
        <p>{t('Current or Future Fiscal Year(s)')}</p>
      </div>
      <GridWrapper
        columns={columns}
        className="noCursorPointer"
        DataItemKey="rowId"
        dataSource={activeFY}
        style={{ maxHeight: '440px' }}
        gridToolbarChildren={<FiscalYearsTableGridToolbar />}
        selectable={selectable}
        hideScrollBar
      />
      <div className="mt-2" />
      <Accordion title={t('Previous Fiscal Year(s)')}>
        <GridWrapper
          className="previousFiscalYearTable"
          columns={columns}
          DataItemKey="rowId"
          loading={isGlPeriodsLoading}
          dataSource={pastFY}
          selectable={selectable}
          hideScrollBar
        />
      </Accordion>
    </div>
  );
};

export default FiscalYearsTable;
